export default __webpack_public_path__ + "static/media/whatDoc.29ef4f80.png";